import $cookies from 'vue-cookies'

import Vue from 'vue'
import Router from 'vue-router'
import { getMenuList } from "../utils/interface";
import loginPage from '@/views/login/index'  //登录
import loginIndex from '@/views/login/loginIndex'  //登录2
import forgetPassword from '@/views/login/forgetPassword'  //忘记密码
import registeredIndex from '@/views/login/registeredIndex'  //免费注册
import main from '@/views/index'
import homePage from '@/views/home/homePage'  //首页
// 交易
import designOrderList from '@/views/transaction/orderManagement/designOrderList'   //打印订单
import modelOrderList from '@/views/transaction/orderManagement/modelOrderList'   //模型订单
import myQuoteList from '@/views/transaction/orderManagement/myQuoteList'   //我的报价
import moneyBackOrderList from '@/views/transaction/orderManagement/moneyBackOrderList'   //退款管理
import evaluationManagement from '@/views/transaction/evaluationManagement'   //评价管理
import complaintsMine from '@/views/transaction/complaintsMine'   //我被投诉
import complaintOrder from '@/views/transaction/complaintOrder'   //我要申诉
// 交易订单评价详情
import designOrderDetail from '@/views/transaction/orderManageMentDetails/designOrderDetail'   //设计订单详情页
import modelOrderDetail from '@/views/transaction/orderManageMentDetails/modelOrderDetail'   //模型订单详情

// 作品
import modelManagement from '@/views/production/modelManagement'   //模型管理
import productDisplay from '@/views/production/productDisplay'   //成果展示
import worksManagement from '@/views/production/worksManagement'   //平面设计
// 店铺
import storeDecorate from '@/views/store/storeDecorate'   // 店铺装修
import storeMessage from '@/views/store/storeMessage'   // 个人信息
// 收藏
import demandCollection from '@/views/collection/demandCollection'   // 需求收藏

//消息
import stationMessageLog from '@/views/transaction/stationMessageLog/stationMessageLog'
// 发票管理
import myInvoice from '@/views/transaction/invoice/myInvoice'   //我的发票

// 账户管理
import accountManagement from '@/views/settlement/accountManagement'   //账户管理

// 结算订单管理
import orderBalanceManagement from '@/views/balance/orderBalanceManagement'

// 银行卡管理
import bankCardManage from '@/views/balance/bankCardManage'
import settlementCard from '@/views/balance/settlementCard' // 结算卡管理

import pageSetting from '@/views/pageSetting/pageSettingManage'

Vue.use(Router)
const originalReplace = Router.prototype.replace;
Router.prototype.replace = function replace(location) {
    return originalReplace.call(this, location).catch(err => err);
};
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}
const router = new Router({
    routes: [
        // {
        //     path: '/',
        //     name: 'login',
        //     redirect: '/login',
        //     component: loginPage,
        // },
        {
            path: '/',
            name: 'loginIndex',
            redirect: '/loginIndex',
            component: loginIndex,
        },
        // {
        //     path: '/login',
        //     name: 'login',
        //     component: loginPage,
        // },
        {
            path: '/loginIndex',
            name: 'loginIndex',
            component: loginIndex,
        },
        {
            path: '/forgetPassword',
            name: 'forgetPassword',
            component: forgetPassword,
        },
        {
            path: '/registeredIndex',
            name: 'registeredIndex',
            component: registeredIndex,
        },
        {
            path: '/home',
            name: 'home',
            redirect: '/home',
            component: main,
            children: [
                {
                    path: '/home',
                    name: 'home',
                    component: homePage,
                    meta: { title: '首页' }
                },
                {
                    path: '/designOrderList',
                    name: 'designOrderList',
                    component: designOrderList,
                    meta: { title: '设计订单' }
                },
                {
                    path: '/designOrderDetail/:uuid',
                    name: 'designOrderDetail',
                    component: designOrderDetail,
                    meta: { title: '设计订单详情页' }
                },
                {
                    path: '/modelOrderList',
                    name: 'modelOrderList',
                    component: modelOrderList,
                    meta: { title: '模型订单' }
                },
                {
                    path: '/modelOrderDetail',
                    name: 'modelOrderDetail',
                    component: modelOrderDetail,
                    meta: { title: '模型订单详情' }
                },
                {
                    path: '/myQuoteList',
                    name: 'myQuoteList',
                    component: myQuoteList,
                    meta: { title: '我的报价' }
                },
                {
                    path: '/moneyBackOrderList',
                    name: 'moneyBackOrderList',
                    component: moneyBackOrderList,
                    meta: { title: '退款管理' }
                },
                {
                    path: '/evaluationManagement',
                    name: 'evaluationManagement',
                    component: evaluationManagement,
                    meta: { title: '评价管理' }
                },
                {
                    path: '/complaintsMine',
                    name: 'complaintsMine',
                    component: complaintsMine,
                    meta: { title: '我被投诉' }
                },
                {
                    path: '/complaintOrder',
                    name: 'complaintOrder',
                    component: complaintOrder,
                    meta: { title: '我要申诉' }
                },
                {
                    path: '/modelManagement',
                    name: 'modelManagement',
                    component: modelManagement,
                    meta: { title: '模型管理' }
                },
                {
                    path: '/productDisplay',
                    name: 'productDisplay',
                    component: productDisplay,
                    meta: { title: '成果展示' }
                },
                {
                    path: '/worksManagement',
                    name: 'worksManagement',
                    component: worksManagement,
                    meta: { title: '平面设计' }
                },
                {
                    path: '/storeDecorate',
                    name: 'storeDecorate',
                    component: storeDecorate,
                    meta: { title: '店铺装修' }
                },
                {
                    path: '/storeMessage',
                    name: 'storeMessage',
                    component: storeMessage,
                    meta: { title: '个人信息' }
                },
                {
                    path: '/demandCollection',
                    name: 'demandCollection',
                    component: demandCollection,
                    meta: { title: '需求收藏' }
                },
                {
                    path: '/stationMessageLog',
                    name: 'stationMessageLog',
                    component: stationMessageLog,
                    meta: {title: '消息'}
                },
                {
                    path: '/myInvoice',
                    name: 'myInvoice',
                    component: myInvoice,
                    meta: {title: '我的发票'}
                },
                {
                    path: '/accountManagement',
                    name: 'accountManagement',
                    component: accountManagement,
                    meta: {title: '账户管理'}
                },
                {
                    path: '/orderBalanceManagement',
                    name: 'orderBalanceManagement',
                    component: orderBalanceManagement,
                    meta: {title: '结算订单'}
                },
                {
                    path: '/bankCardManage',
                    name: 'bankCardManage',
                    component: bankCardManage,
                    meta: {title: '提现卡管理'}
                },
                {
                    path: '/settlementCard',
                    name: 'settlementCard',
                    component: settlementCard,
                    meta: {title: '结算卡管理'}
                },
                {
                    path: '/pageSetting',
                    name: 'pageSetting',
                    component: pageSetting,
                    meta: {title: '主页设置'}
                },
            ]
        },
    ]
})
router.beforeEach(async(to, from, next) => {
    let token = $cookies.get("api_token_new");
    let authoritiesMess = $cookies.get("authoritiesMess")
    // let menuList = JSON.parse(window.sessionStorage.getItem('menuList') || '[]')

    if (to.name !== 'loginIndex' && !token) {
        next({ name: 'loginIndex' })
        return
    }
    // if(to.name === 'login' && token && menuList.length > 0){
    if(to.name === 'loginIndex' && token  && authoritiesMess == 'designerCenterService'){
        next({ name: 'home' })
        return
    }
    // if(token && menuList.length <= 0){
    if(token && authoritiesMess != 'designerCenterService') {
        getMenuList().then(res=>{
            if(res.length > 0){
                window.sessionStorage.setItem('menuList', JSON.stringify(res || []))
                Vue.prototype.resetSetItem('menuActiveId',res[0].uuid)
                // 成功后直接跳转
                next({ name: 'home' })
                return
            } else {
                Vue.prototype.$alert('权限不足，请联系管理员!', "提示", {
                    confirmButtonText: "确定",
                    callback: action => {
                        next({ name: 'loginIndex' })
                        return
                    }
                })
            }
        })

    }
    next()
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js